export const SuperHostBadge = () => {
  return (
    <div
      className="flex h-[37px] w-full items-center justify-center rounded-t-sm"
      style={{
        background:
          'linear-gradient(0deg, rgba(255, 255, 255, 0.17) 0%, rgba(255, 255, 255, 0.17) 100%), linear-gradient(90deg, rgba(78, 144, 249, 0.00) 24.88%, rgba(54, 130, 250, 0.60) 53.56%, rgba(78, 144, 249, 0.00) 91.72%), linear-gradient(90deg, rgba(137, 95, 252, 0.00) -96%, #9E7AFF 31.49%, rgba(137, 95, 252, 0.00) 215.24%), #FFF;',
      }}
    >
      <span className="typo-label1 font-semibold text-white">
        삼삼엠투 인기 호스트
      </span>
    </div>
  )
}
